/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function () {
  angular.module('cbl.telepass.wa').service('TlpsPostVenditaSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    '$state',
    '$stateParams',
    function ($http, messaggiFctr, CONSTANTS, labelSrvc, $state, $stateParams) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;
      this.$state = $state;
      this.$stateParams = $stateParams;

      // Variabili generali pratica
      this.datiCliente = null;
      this.datiPratica = null;

      this.contrattoDaRevocare = null;
      this.ndgContrattoDaRevocare = null;
      this.contrattiCliente = null;

      // Spinner
      this.spinner = { showSpinner: false, callStack: 0 };

      var self = this;

      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name promiseRecuperaContiCorrenti
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i conti correnti dell'ndg
       * @return {Promise} - Ritorna una promise contenente la lista dei conti correnti
       */
      this.promiseRecuperaContiCorrenti = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CONTOCORRENTE.RICERCA_CONTICORRENTE,
          params: { ndg: ndg }
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaAnagrafica
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i dettagli dell'anagrafica
       * @return {Promise} - Ritorna una promise contenente l'anagrafica
       */
      this.promiseRecuperaAnagrafica = function (ndg) {
        // this.spinner.pratica = true;
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.RECUPERA,
          params: { ndg: ndg }
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioPratica
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i dettagli della pratica
       * @return {Promise} - Ritorna una promise contenente i dettagli della pratica
       */
      this.promiseRecuperaPratica = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA + 'pratica/' + idPratica
        });
      };

      /**
       * SERVIZI REVOCA
       */

      this.promiseRecuperaContrattiCliente = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.RECUPERA_CONTRATTI_CLIENTE + ndg
        });
      };

      this.promiseRevocaTelepass = function (ndg, contratto) {
        var req = {
          ndg: ndg,
          codiciContratto: contratto
        };

        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.REVOCA,
          data: req
        });
      };

      this.promiseModificaConto = function (rapporto, ndg, contratto) {
        var req = {
          numeroRapporto: rapporto,
          ndg: ndg,
          codiceContratto: contratto
        };

        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.MODIFICA_CONTO,
          data: req
        });
      };

      /**
       * SERVIZI RESTITUZIONE
       */

      this.promiseRecuperaCarteViacardPerContratto = function (contratto, ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.RECUPERA_CARTE_VIACARD + contratto,
          params: { ndg: ndg }
        });
      };

      this.promiseRecuperaCarteViacard = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.RECUPERA_CARTE_VIACARD + ndg
        });
      };

      this.promiseRestituisciCarte = function (ndg, listaCarte, codiceContratto) {
        var req = {
          ndg: ndg,
          carteViacard: listaCarte,
          codiceContratto: codiceContratto
        };

        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.RESTITUISCI_CARTE,
          data: req
        });
      };

      this.promiseAggiungiCarte = function (ndg, numeroCarte, codiceContratto) {
        var req = {
          ndg: ndg,
          numeroCarte: numeroCarte,
          codiceContratto: codiceContratto
        };

        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.AGGIUNGI_CARTE,
          data: req
        });
      };

      /**
       * @ngdoc method
       * @name promiseRisottomettiPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per rifiutare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con la risposta alla cancellazione
       */
      this.promiseRisottomettiPratica = function () {
        var pratica = self.datiPratica;

        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.RISOTTOMETTI_PRATICA.replace('{idPratica}', pratica.idPratica),
          data: pratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseRifiutaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per rifiutare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con la risposta alla cancellazione
       */
      this.promiseRifiutaPratica = function (pratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.RIFIUTA_PRATICA.replace('{idPratica}', pratica.idPratica),
          data: pratica
        });
      };

      /**
       * @ngdoc method
       * @name formattazioneData
       * @methodOf cbl.telepass.wa:CcpropostaTelepassSrvc
       * @description Formatta la data per visualizzarla
       */
      this.formattazioneData = function (data) {
        if (!data) {
          return '';
        }

        var giorno = data.dayOfMonth;
        var mese = data.monthValue;
        var anno = data.year;

        return giorno + '/' + mese + '/' + anno;
      };

      /**
       * @ngdoc method
       * @name goToSchedaCliente
       * @methodOf cbl.telepass.wa.directive:tlpsProposta
       * @description Ridireziona verso la scheda del cliente
       */
      this.goToSchedaCliente = function () {
        self.datiPratica = null;
        self.datiCliente = null;
        self.datiProdotto = null;
        self.$state.go('schedaCliente', { ndg: self.$stateParams.ndg });
      };

      this.recuperaContratti = function () {
        self.messaggiFctr.resetMessages();
        self.ndg = self.$stateParams.ndg;
        self.numeroRapportoDaModificare = null;

        self.spinner.callStack++;
        // Recupero il codice cliente per farlo visualizzare
        self.promiseRecuperaContrattiCliente(self.ndg).then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.contrattiCliente = response.data.result;

            // Se ho i dati della pratica e il codiceContratto della pratica vuol dire che la devo
            // risottomettere
            if (self.datiPratica && self.datiPratica.codiceContratto) {
              // self.datiPratica.stato ===
              //   self.CONSTANTS.STATO_PRATICA.DAREVISIONARE
              self.contrattiCliente = self.contrattiCliente.filter(function (item) {
                return item.codiceContratto === self.datiPratica.codiceContratto;
              });

              self.selectedButtonsCellTemplate = self.risottomettiButtonCellTemplate;
            }

            self.tableHeight = response.data.result.length * 35 + 40;
            self.spinner.callStack--;

            // // Configurazione tabella
            var _defaultRowheight = 35;
            self.gridOptions = {
              enableSorting: true,
              enableColumnMenus: false,
              enableGrouping: false,
              // multiSelect: true,
              showHeader: true,
              enableRowHeaderSelection: false,
              // enableRowSelection: true,
              showGridFooter: false,
              enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableColumnResizing: true,
              rowHeight: _defaultRowheight,
              columnDefs: [
                {
                  displayName: 'Codice Contratto',
                  field: 'codiceContratto',
                  width: '8%',
                  name: 'codiceContratto'
                },
                {
                  displayName: 'Settore',
                  field: 'settore',
                  width: '8%',
                  name: 'settore'
                },
                {
                  displayName: 'Data Apertura',
                  field: 'dataAperturaContratto',
                  width: '10%',
                  name: 'dataAperturaContratto'
                },
                {
                  displayName: 'Numero modulo apertura',
                  field: 'numeroModulo',
                  width: '5%',
                  name: 'numeroModulo'
                },
                {
                  displayName: 'Numero rapporto TLP',
                  field: 'numeroRapportoTLP',
                  width: '10%',
                  name: 'numeroRapportoTLP'
                },
                {
                  displayName: 'IBAN',
                  field: 'iban',
                  width: '10%',
                  name: 'iban'
                },
                {
                  displayName: 'Apparati',
                  field: 'numeroApparati',
                  width: '5%',
                  name: 'numeroApparati'
                },
                {
                  displayName: 'Carte',
                  field: 'numeroCarte',
                  width: '8%',
                  name: 'numeroCarte'
                },
                {
                  displayName: 'Azioni',
                  field: 'numeroCarte',
                  width: '36%',
                  name: 'azioni',
                  cellTemplate:
                    '<span>' +
                    '<span style="margin: 5px;">' +
                    '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.openModaleRevocaContratto(row.entity.codiceContratto)">Revoca</button>' +
                    '</span>' +
                    '<span style="margin: 5px;" ng-if="row.entity.settore===grid.appScope.postVenditaTelepassCtrl.labelViacard">' +
                    '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.avviaRestituzioneCarte(row)">Restituisci</button>' +
                    '</span>' +
                    '<span style="margin: 5px;" ng-if="row.entity.settore===grid.appScope.postVenditaTelepassCtrl.labelViacard">' +
                    '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.avviaAggiuntaCarte(row)">Aggiungi</button>' +
                    '</span>' +
                    '<span>' +
                    '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.avviaModificaConto(row)">Modifica Conto</button>' +
                    '</span>' +
                    '</span>'
                }
              ],
              data: self.contrattiCliente,
              onRegisterApi: function (gridApi) {
                self.gridApi = gridApi;
                self.gridApi.grid.modifyRows(self.gridOptions.data);
              }
            };
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.spinner.callStack--;
          }
        );
      };

      this.pulisciDati = function () {};
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsPostVendita/tlpsPostVenditaSrvc.js
// module id = 20
// module chunks = 0